export enum Variant {
	OneOnOnesExperimental = 'one-on-ones-experimental',
	OneOnOnesR3FastFollows = 'achieve-adoption-r3-fast-follows',
	OpenOneOnOnes = 'open-one-on-ones',
	RemoveHomepageWidgetColumn = 'remove-homepage-widget-column',
	BizyForParticipation = 'bizy-for-participation',
	BizyConversationHistory = 'bizy_conversation_history',
	HidePlanMigrationModal = 'hide-plan-migration-modal',
}
